/**
 * The business track, bundled into the public page.
 *
 * Public and unauthenticated, which is the constraint that shapes what may appear
 * here: nothing on this track states, implies or exemplifies a **platform**
 * commission figure. The tenant legs are the bank's own and are used freely,
 * including in the worked example on `pricing-and-commission`; the platform pair is
 * described as agreed commercially and never given a number. See the header of
 * `business/pricing-and-commission.ts`.
 *
 * Order matters twice. Groups render in first-appearance order in the sidebar, and
 * pages render in array order within their group — so this list *is* the reading
 * order, and the landing page has to be first.
 */

import type { Page } from '../types.js';
import landing from './business/landing.js';
import whatItIs from './business/what-it-is.js';
import howItWorks from './business/how-it-works.js';
import surfaces from './business/surfaces.js';
import pricing from './business/pricing-and-commission.js';
import security from './business/security-and-trust.js';
import rollout from './business/rollout.js';
import operations from './business/operations.js';

export const BUSINESS_PAGES: Page[] = [
  landing,
  whatItIs,
  howItWorks,
  surfaces,
  pricing,
  security,
  rollout,
  operations,
];
